import { Link } from "react-router-dom";
import { isAgentPortal } from "js/utilities";
import { useBreadcrumb } from "hooks/useBreadcrumb";
import { Trans, useTranslation } from "react-i18next";
export default function CaliforniaConsumerPrivacyStatement() {
  const { t } = useTranslation();

  useBreadcrumb([
    {
      name: "Home",
      url: `${isAgentPortal() ? "/dashboard" : "/policies"}`,
    },
    { name: "California Privacy Statement", url: "#" },
  ]);
  return (
    <>
      <div className="container ui-component-spacing">
        <h1>{t("CaliforniaConsumerPrivacyStatement-title")}</h1>
        <hr />
      </div>

      <div className="container ui-component-spacing font-body">
        <p className="mb-6">
          {t("CaliforniaConsumerPrivacyStatement-effectiveDate")}
        </p>
        <p>
          <Trans
            i18nKey="CaliforniaConsumerPrivacyStatement-section1"
            components={{ link1: <Link to="/privacy-policy" /> }}
          />
        </p>
        <br />
        <p>{t("CaliforniaConsumerPrivacyStatement-section1-para1")}</p>

        <br />

        <Trans
          i18nKey="CaliforniaConsumerPrivacyStatement-section2"
          components={{ p: <p />, h2: <h2 />, br: <br /> }}
        />
        <ul className="list-disc list-outside pl-5">
          <li>{t("CaliforniaConsumerPrivacyStatement-section2-list1")}</li>
          <li>{t("CaliforniaConsumerPrivacyStatement-section2-list2")}</li>
          <li>{t("CaliforniaConsumerPrivacyStatement-section2-list3")}</li>
          <li>{t("CaliforniaConsumerPrivacyStatement-section2-list4")}</li>
          <li>{t("CaliforniaConsumerPrivacyStatement-section2-list5")}</li>
          <Trans
            i18nKey="CaliforniaConsumerPrivacyStatement-section2-list6"
            components={{ li: <li /> }}
          />
        </ul>
        <br />

        <p>{t("CaliforniaConsumerPrivacyStatement-section2-para1")}</p>

        <br />
        <ul className="list-disc list-outside pl-5">
          <li>{t("CaliforniaConsumerPrivacyStatement-section3-list1")}</li>
          <li>{t("CaliforniaConsumerPrivacyStatement-section3-list2")}</li>
          <Trans
            i18nKey="CaliforniaConsumerPrivacyStatement-section3-list3"
            components={{ li: <li /> }}
          />
        </ul>

        <br />
        <Trans
          i18nKey="CaliforniaConsumerPrivacyStatement-section4"
          components={{ h2: <h2 />, br: <br /> }}
        />

        <br />

        <ul className="list-disc list-outside pl-5">
          <Trans
            i18nKey="CaliforniaConsumerPrivacyStatement-section4-list1"
            components={{ li: <li /> }}
          />
        </ul>

        <br />

        <Trans
          i18nKey="CaliforniaConsumerPrivacyStatement-section5"
          components={{ p: <p />, h2: <h2 />, br: <br /> }}
        />

        <Trans
          i18nKey="CaliforniaConsumerPrivacyStatement-section6"
          components={{ p: <p />, h2: <h2 />, br: <br /> }}
        />

        <br />

        <ul className="list-disc list-outside pl-5">
          <Trans
            i18nKey="CaliforniaConsumerPrivacyStatement-section6-list1"
            components={{ li: <li /> }}
          />
          <Trans
            i18nKey="CaliforniaConsumerPrivacyStatement-section6-list2"
            components={{ li: <li /> }}
          />
          <Trans
            i18nKey="CaliforniaConsumerPrivacyStatement-section6-list3"
            components={{ li: <li /> }}
          />
        </ul>

        <br />

        <p>{t("CaliforniaConsumerPrivacyStatement-section6-footer")}</p>

        <br />

        <Trans
          i18nKey="CaliforniaConsumerPrivacyStatement-section7"
          components={{ p: <p />, h2: <h2 />, br: <br /> }}
        />

        <p>
          <i>
            {t("CaliforniaConsumerPrivacyStatement-section7-submitRequest")}
          </i>
          <br />
          <Trans
            i18nKey="CaliforniaConsumerPrivacyStatement-section7-submitRequest-desc"
            components={{
              emailLink: <a href="mailto:info@everlakelife.com" />,
              phoneLink: <a href="tel:+1-888-885-8912" />,
              authorizedAgentEmail: <a href="mailto:info@everlakelife.com" />,
              privacyPolicyLink: <Link to="/privacy-policy" />,
            }}
          />
        </p>
        <br />

        <p>
          <Trans
            i18nKey="CaliforniaConsumerPrivacyStatement-section7-verifyingRequest"
            components={{ i: <i />, br: <br /> }}
          />
        </p>
        <br />

        <p>
          <Trans
            i18nKey="CaliforniaConsumerPrivacyStatement-section7-additionalInformation"
            components={{ i: <i />, br: <br /> }}
          />
        </p>
        <br />
      </div>
    </>
  );
}
